import { render, staticRenderFns } from "./Corse.vue?vue&type=template&id=18f9e18f&scoped=true"
import script from "./Corse.vue?vue&type=script&lang=js"
export * from "./Corse.vue?vue&type=script&lang=js"
import style0 from "./Corse.vue?vue&type=style&index=0&id=18f9e18f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f9e18f",
  null
  
)

export default component.exports